export const POI_RATING_TAGS = [
  { key: "cleanliness", label: "Cleanliness", color: "bg-emerald-100 text-emerald-800" },
  { key: "staff", label: "Staff", color: "bg-blue-100 text-blue-800" },
  { key: "wait_time", label: "Wait Time", color: "bg-orange-100 text-orange-800" },
  { key: "fun", label: "Fun", color: "bg-purple-100 text-purple-800" },
  { key: "food_quality", label: "Food Quality", color: "bg-amber-100 text-amber-800" },
  { key: "accessibility", label: "Accessibility", color: "bg-sky-100 text-sky-800" },
  { key: "value", label: "Value", color: "bg-rose-100 text-rose-800" },
] as const;

export type POIRatingTagKey = (typeof POI_RATING_TAGS)[number]["key"];

export function getTagColor(key: string): string {
  return POI_RATING_TAGS.find((t) => t.key === key)?.color ?? "bg-muted text-muted-foreground";
}

export function getTagLabel(key: string): string {
  return POI_RATING_TAGS.find((t) => t.key === key)?.label ?? key;
}
